import School from "../models/School";
import SharePointApp from "../models/SharePointApp";
import { CronOption } from "./CronOption";
import { IDropdownOption } from "office-ui-fabric-react/lib-commonjs";
import { DurableFunctionInstanceHelpers, GroundFloorDurableFunctionInstance } from "../models/DurableFunctionInstance";
import moment, { Moment } from "moment";
import * as _ from "lodash";

export const friendlySchoolName = (school: School) => {
    if (school == null) {
        return "";
    }

    if (school.schoolName) {
        return school.schoolName
    }

    return unfriendlySchoolName(school);
}
export const unfriendlySchoolName = (school: School | { tenantName?: string, tenantId?: string, schoolCode: string }) => `${school.tenantName || school.tenantId} - ${school.schoolCode}`;

export const FRIENDLY_DATE_FORMAT = "DD/MM/YYYY"
export const FRIENDLY_TIME_FORMAT = "HH:mm";
export const FRIENDLY_DATETIME_FORMAT = FRIENDLY_TIME_FORMAT + " " + FRIENDLY_DATE_FORMAT;

export const sharePointAppKey = (SharePointApp: SharePointApp) => `${SharePointApp.tenantId}${SharePointApp.name}`;

export const unfriendlyDurableFunctionInstanceName = (instance: GroundFloorDurableFunctionInstance) => {
    let name = DurableFunctionInstanceHelpers.GetDurableFunctionInstanceName(instance);

    return `${name} [${instance.durableFunctionInstanceId}]`;
}

export const calcIsFailedAndAwaitingRestart = (instance?: GroundFloorDurableFunctionInstance) => {
    return !!instance?.playlistName && instance.failedAndAwaitingRestart
}

export const CRON_OPTIONS: CronOption[] = [
    { cronString: "0 01 * * 1-5", desc: "At 01:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 1 * * 1-5", desc: "At 01:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 02 * * 1-5", desc: "At 02:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 2 * * 1-5", desc: "At 02:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 03 * * 1-5", desc: "At 03:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 03 * * 1-5", desc: "At 03:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 04 * * 1-5", desc: "At 04:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 04 * * 1-5", desc: "At 04:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 05 * * 1-5", desc: "At 05:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 05 * * 1-5", desc: "At 05:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 06 * * 1-5", desc: "At 06:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 06 * * 1-5", desc: "At 06:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 07 * * 1-5", desc: "At 07:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 07 * * 1-5", desc: "At 07:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 08 * * 1-5", desc: "At 08:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 08 * * 1-5", desc: "At 08:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 09 * * 1-5", desc: "At 09:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 09 * * 1-5", desc: "At 09:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 10 * * 1-5", desc: "At 10:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 10 * * 1-5", desc: "At 10:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 11 * * 1-5", desc: "At 11:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 11 * * 1-5", desc: "At 11:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 12 * * 1-5", desc: "At 12:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 12 * * 1-5", desc: "At 12:30 on every day-of-week from Monday through Friday" },
    { cronString: "0 13 * * 1-5", desc: "At 13:00 on every day-of-week from Monday through Friday" },
    { cronString: "0 17 * * 1-5", desc: "At 17:00 on every day-of-week from Monday through Friday" },
    { cronString: "0 19 * * 1-5", desc: "At 19:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 19 * * 1-5", desc: "At 19:30 on every day-of-week from Monday through Friday" },
    { cronString: "00 20 * * 1-5", desc: "At 20:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 20 * * 1-5", desc: "At 20:30 on every day-of-week from Monday through Friday" },
    { cronString: "00 21 * * 1-5", desc: "At 21:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 21 * * 1-5", desc: "At 21:30 on every day-of-week from Monday through Friday" },
    { cronString: "00 22 * * 1-5", desc: "At 22:00 on every day-of-week from Monday through Friday" },
    { cronString: "30 22 * * 1-5", desc: "At 22:30 on every day-of-week from Monday through Friday" },
    { cronString: "00 23 * * 1-5", desc: "At 23:00 on every day-of-week from Monday through Friday" },
    { cronString: "0 01 * * 6", desc: "At 01:00 on Saturday" },
    { cronString: "0 06 * * 6", desc: "At 06:00 on Saturday" },
    { cronString: "0 01 * * 0", desc: "At 01:00 on Sunday" },
    { cronString: "0 06 * * 0", desc: "At 06:00 on Sunday" },
    { cronString: "0 01 * * 0-6", desc: "At 01:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 1 * * 0-6", desc: "At 01:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 02 * * 0-6", desc: "At 02:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 2 * * 0-6", desc: "At 02:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 03 * * 0-6", desc: "At 03:00 on every day-of-week from Monday through Sunday" },
    { cronString: "0 05 * * 0-6", desc: "At 05:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 05 * * 0-6", desc: "At 05:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 06 * * 0-6", desc: "At 06:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 06 * * 0-6", desc: "At 06:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 07 * * 0-6", desc: "At 07:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 07 * * 0-6", desc: "At 07:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 08 * * 0-6", desc: "At 08:00 on every day-of-week from Monday through Sunday" },
    { cronString: "30 08 * * 0-6", desc: "At 08:30 on every day-of-week from Monday through Sunday" },
    { cronString: "0 09 * * 0-6", desc: "At 09:00 on every day-of-week from Monday through Sunday" },

    { cronString: "30 02 * * *", desc: "At 02:30 every day" },
    { cronString: "30 05 * * *", desc: "At 05:00 every day" },
    { cronString: "20 11,15 * * 1-5", desc: "At 11.20am and 3.20pm on every day-of-week from Monday through Friday - Useful for wake teams" },

    { cronString: "0 04 * * 0,2,4,6", desc: "At 04:00 on Sunday, Tuesday, Thursday, and Saturday." },
    { cronString: "0 16 * * 0,2,4,6", desc: "At 16:00 on Sunday, Tuesday, Thursday, and Saturday." },
    { cronString: "0 22 * * 0,2,4,6", desc: "At 22:00 on Sunday, Tuesday, Thursday, and Saturday." },

    { cronString: "0 04 * * 1,3,5", desc: "At 04:00 on Monday, Wednesday, and Friday." },
    { cronString: "0 16 * * 1,3,5", desc: "At 16:00 on Monday, Wednesday, and Friday." },
    { cronString: "0 22 * * 1,3,5", desc: "At 22:00 on Monday, Wednesday, and Friday." }

];


export const INDEXED_CRON_OPTIONS: { [key: string]: CronOption } = CRON_OPTIONS.reduce((acc: { [key: string]: CronOption }, cronOption: CronOption) => {
    acc[cronOption.cronString] = cronOption;
    return acc;
}, {});

export const CRON_DROPDOWN_OPTIONS: IDropdownOption[] = CRON_OPTIONS.map((cronOption): IDropdownOption => {
    return {
        key: cronOption.cronString,
        text: cronOption.desc,
        data: cronOption
    };
});

export const CSS_BREAKPOINT_SMALL = "768px";

export type QueryObject = { [key: string]: string }

export const parseQueryString = (queryString: string): QueryObject => {

    const queryObject: QueryObject = {};

    if (queryString.indexOf("?") === 0) {
        queryString = queryString.slice(1);
    }

    return queryString.split("&").reduce((acc: QueryObject, keyVal: string) => {

        const parts = keyVal.split("=");
        acc[parts[0]] = parts[1];

        return acc;
    }, queryObject);
};


export const getAnyProperty = (object: any, preferredPropertyNames: string[]): { propertyName: string, value: any } | undefined => {
    if (!object) {
        return undefined;
    }

    for (const propertyName of preferredPropertyNames) {
        const value = _.get(object, propertyName);
        if (value) {
            return { propertyName, value }
        }
    }

    const propertyName = Object.keys(object)[0];
    return {
        propertyName: propertyName,
        value: object[propertyName]
    };
}

export const openFileDownload = async (result: any) => {
    const link = document.createElement('a');

    const blob = await result.blob();
    link.href = window.URL.createObjectURL(blob);

    const name = result.headers.get('content-disposition')?.split('filename=')[1]?.split(';')[0];
    link.download = name!.replaceAll('"', '');

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

}

export const getDateOnlyFromDateTimeString = (dateString: string | undefined): Moment => {

    var dateTime = moment(dateString);

    if (!dateTime.isValid()) {
        return moment(0);
    }

    var date = dateTime.startOf('year');

    return date;
}

export const getDateRange = (start: string, end: string): Moment[] => {
    var dateArray: Moment[] = [];
    var currentDate = moment(start);
    var endDate = moment(end);
    while (currentDate <= endDate) {
        dateArray.push(moment(currentDate))
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
}

export const doubleEncodeURIComponent = (value: string): string => encodeURIComponent(encodeURIComponent(value));

export const formatFloat = (value: number) => {
    return value.toFixed(2);
}

export const formatPercentage = (value: number) => {
    return `${formatFloat(value)}%`;
}
